import { TICK_EXT } from "building-types/constants/dimensionConstants";
import { line2VecPerp, lineStartPt, lineEndPt } from "geom/line2Polyline2";
import { polyLine2ByTwoPoints, polyLine2ExtendEnd, polyLine2ExtendStart } from "geom/polyLine2";
import { polyLine2New, type PolyLine2 } from "geom/polyLine2Types";
import { getLine } from "geom/rect2";
import { vec2Scale } from "geom/vec2";

export function orientedTickAtPoint(tx: number, ty: number, x: number, y: number, tickLen = TICK_EXT): PolyLine2 {
  const [tickax, tickay] = vec2Scale(-ty, tx, tickLen / 2);
  const [tickbx, tickby] = vec2Scale(tx, ty, -tickLen / 2);

  return polyLine2ByTwoPoints(x + tickax + tickbx, y + tickay + tickby, x - tickax - tickbx, y - tickay - tickby);
}

export function dimensionDimlineNew({
  pl,
  dimExt,
  baseLineOffset,
  baseLine: manualBaseLine,
}: {
  pl: PolyLine2;
  dimExt: number;
  baseLineOffset: number;
  baseLine?: PolyLine2;
}): PolyLine2 {
  const baseLine = manualBaseLine ?? getLine(pl, 0);
  const pVec = line2VecPerp(baseLine);
  const line = manualBaseLine ? pl : makeDimLine(baseLine, pVec, baseLineOffset);

  const startPt = lineStartPt(line);
  const endPt = lineEndPt(line);

  const dimLine = polyLine2New(4);
  dimLine[0] = startPt[0];
  dimLine[1] = startPt[1];
  dimLine[2] = endPt[0];
  dimLine[3] = endPt[1];

  polyLine2ExtendEnd(dimLine, dimExt);
  polyLine2ExtendStart(dimLine, dimExt);
  return dimLine;
}
export function makeDimLine(line: PolyLine2, pVec: PolyLine2, dimL: number): PolyLine2 {
  const dimLine = polyLine2New(4);
  dimLine[0] = line[0] + pVec[0] * dimL;
  dimLine[1] = line[1] + pVec[1] * dimL;
  dimLine[2] = line[2] + pVec[0] * dimL;
  dimLine[3] = line[3] + pVec[1] * dimL;

  return dimLine;
}
